var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRedemption(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.05 11.1929C2.60357 11.6393 2.60357 12.3643 3.05 12.8107L7.62143 17.3821C8.06786 17.8286 8.79286 17.8286 9.23929 17.3821C9.68571 16.9357 9.68571 16.2107 9.23929 15.7643L6.61786 13.1429L14.1429 13.1429C14.775 13.1429 15.2857 12.6321 15.2857 12C15.2857 11.3679 14.775 10.8571 14.1429 10.8571L6.61786 10.8571L9.23929 8.23571C9.68571 7.78929 9.68571 7.06428 9.23929 6.61786C8.79286 6.17143 8.06786 6.17143 7.62143 6.61786L3.05 11.1893V11.1929ZM15.2857 17.7143C14.6536 17.7143 14.1429 18.225 14.1429 18.8571C14.1429 19.4893 14.6536 20 15.2857 20H17.5714C19.4643 20 21 18.4643 21 16.5714V7.42857C21 5.53571 19.4643 4 17.5714 4H15.2857C14.6536 4 14.1429 4.51071 14.1429 5.14286C14.1429 5.775 14.6536 6.28571 15.2857 6.28571H17.5714C18.2036 6.28571 18.7143 6.79643 18.7143 7.42857V16.5714C18.7143 17.2036 18.2036 17.7143 17.5714 17.7143H15.2857Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRedemption);
export default __webpack_public_path__ + "static/media/icon-redemption.77da31e4643e4cb0080571b76f03ba14.svg";
export { ForwardRef as ReactComponent };